
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/png-compressor",
      function () {
        return require("private-next-pages/png-compressor/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/png-compressor"])
      });
    }
  